export const ACCESS_TOKEN_NAME_IN_LOCAL_STORAGE = "accessToken";
export const GRANT_ID_NAME_IN_LOCAL_STORAGE = "grantId";
export const REFRESH_TOKEN_NAME_IN_LOCAL_STORAGE = "refreshToken";
export const EMAIL_NAME_IN_LOCAL_STORAGE = "emailAddress";
export const TOKEN_TYPE = "Bearer";
export const TOKEN_EXPIRATION_IN_MILlISECONDS = 3600000; // 60 sec * 60 min * 1000 milliseconds
